import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";

class ContractChangeOrderForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("change_cost", true);
          this.props.setFieldTouched("change_date", true);
          this.props.setFieldTouched("change_order_name", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;

          if (values.change_date) {
            values.change_date = new Date(values.change_date).toJSON();
          }

          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        {" "}
        <fieldset disabled={this.props.disabled}>
          {" "}
          <div
            onClick={this.props.toggleSmallModalHandler}
            style={{ color: "red", float: "right", cursor: "pointer" }}
          >
            x
          </div>
          <small className={"d-block col-12"}>
            <span style={{ color: "red" }}>*</span> required
          </small>
          <label
            className="col-12"
            style={
              this.props.errors.change_cost &&
              this.props.touched.change_cost && { color: "red" }
            }
          >
            Change Cost
            <Field
              className="form-control-sm form-control"
              name={"change_cost"}
              value={this.props.values.change_cost || null}
            />
            {this.props.errors.change_cost &&
              this.props.touched.change_cost && (
                <small className="text-danger">
                  {this.props.errors.change_cost}
                </small>
              )}
          </label>
          <div className={"d-inline-block col-12"}>
            <label
              style={
                this.props.errors.change_date &&
                this.props.touched.change_date && { color: "red" }
              }
              className="required"
            >
              Change Date
            </label>

            <Field
              style={
                this.props.errors.change_date &&
                this.props.touched.change_date && { borderColor: "red" }
              }
              className="form-control-sm form-control"
              name={"change_date"}
              value={this.props.values.change_date || ""}
            />
            {this.props.errors.change_date &&
              this.props.touched.change_date && (
                <small className="text-danger">
                  {this.props.errors.change_date}
                </small>
              )}
          </div>
          <div className={"d-inline-block col-12"}>
            <label
              style={
                this.props.errors.change_order_name &&
                this.props.touched.change_order_name && { color: "red" }
              }
              className="required"
            >
              Change Order Name
            </label>
            <Field
              style={
                this.props.errors.change_order_name &&
                this.props.touched.change_order_name && { borderColor: "red" }
              }
              className="form-control-sm form-control"
              name={"change_order_name"}
              value={this.props.values.change_order_name || ""}
            />
            {this.props.errors.change_order_name &&
              this.props.touched.change_order_name && (
                <small className="text-danger">
                  {this.props.errors.change_order_name}
                </small>
              )}
          </div>
          <div>
            <SelectionFields
              showError={
                this.props.errors.order_change_type_id &&
                this.props.touched.order_change_type_id
              }
              size={"col-12"}
              id={"order_change_type_id"}
              url={`order_change_type_lkp`}
              showElem={"name"}
              label={"Order Change Type"}
              value={this.props.values["order_change_type_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.order_change_type_id &&
                this.props.touched.order_change_type_id && (
                  <small className="text-danger">
                    {this.props.errors.order_change_type_id}
                  </small>
                )
              }
            />
          </div>
          <div>
            <SelectionFields
              size={"col-12"}
              id={"proj_contract_id"}
              url={`proj_contract/project_id/${this.props.projectID}`}
              showElem={"contract_name"}
              label={"Contract"}
              value={this.props.values["proj_contract_id"] || "default"}
              isRequired={false}
            />
            {this.props.errors.proj_contract_id &&
              this.props.touched.proj_contract_id && (
                <small className={"text-danger"}>
                  {this.props.errors.proj_contract_id}
                </small>
              )}
          </div>
          <label className="col-12">
            Content
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"content"}
              value={this.props.values.content || ""}
            />
          </label>
        </fieldset>
        {this.props.disabled ? (
          <Button
            className={"ml-2"}
            type="button"
            onClick={this.props.toggleSmallModalHandler}
          >
            Cancel
          </Button>
        ) : (
          <div>
            {!this.props.currentContractChangeOrder ? (
              <Aux>
                <Button
                  color="blue"
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.add, this.props.values);
                  }}
                >
                  Submit
                </Button>
                <Button
                  color="red"
                  className={"ml-2"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            ) : (
              <Aux>
                <Button
                  color="blue"
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.update, this.props.values);
                  }}
                >
                  Update
                </Button>
                <Button
                  className="ml-2"
                  color={"red"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            )}
            <Button
              className={"ml-2"}
              type="button"
              onClick={this.props.toggleSmallModalHandler}
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    );
  }
}

var contractChangeOrderSchema = Yup.object().shape({
  change_date: Yup.date()
    .typeError("Invalid date")
    .required(),
  change_order_name: Yup.string().required(),
  order_change_type_id: Yup.number().required(),
  change_cost: Yup.number()
    .nullable()
    .typeError("Number required")
});

export default withFormik({
  validationSchema: contractChangeOrderSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentContractChangeOrder }) {
    return {
      ...currentContractChangeOrder
    };
  }
})(ContractChangeOrderForm);
